
export default function Footer(){
    return (
        <section id="footer" className='mt-5 rounded bg-black py-8 px-8'>
            <div className='text-white md:text-center'>

            <p className="text-center text-md text-gray-300 sm:text-center">
                Bingjian Huang, Last Updated January 2025.
            </p>

            </div>

        </section>
    )
}